import { h } from 'preact'
import { IMatchResult } from '../../lib/model'
import styles from './MatchResult.module.css'

interface Props {
  result: IMatchResult
  statusLabel: string
}

function score(scoreVal, statusLabel) {
  return statusLabel === 'Pågår' && !scoreVal ? 0 : scoreVal
}

export function MatchResult(props: Props) {
  return (
    <div
      class={
        props.statusLabel === 'Pågår'
          ? styles['dh-fotball-banner__match-result-ongoing']
          : styles['dh-fotball-banner__match-result']
      }
    >
      <div>{score(props.result.homeScore, props.statusLabel)}</div>
      {props.statusLabel === 'Plannlagt' || props.statusLabel === 'Avlyst' ? <div>-</div> : ''}
      <div>{score(props.result.awayScore, props.statusLabel)}</div>
    </div>
  )
}
